<div class="cipo--border-top--solid p-t" data-testid="activity-item-container">
    @let details = activityDetails();
    @if (details) {
        @if (
            details.message &&
            (details.type !== ACTION_TYPES.UpdateDocument ||
                (details.type === ACTION_TYPES.UpdateDocument && !details.fields?.length))
        ) {
            <app-froala [content]="details.message" [editmode]="false" data-testid="activity-item-message" />
        }
        @if (details.preferredFields && availablePreferredFields().length) {
            <div fxLayout fxLayoutAlign="end center">
                <div fxLayout="column" class="p-l m-r-xxl cipo--border-left--solid">
                    @for (item of availablePreferredFields(); track item.key) {
                        <div
                            fxLayout
                            fxLayoutAlign="start center"
                            fxLayoutGap="12px"
                            [attr.data-testid]="'activity-item-preferred-field-' + item.key">
                            <mat-checkbox
                                [checked]="item.isUsed"
                                [disabled]="preferredValueDisabled()"
                                (change)="togglePreferredValue(item)"
                                data-testid="activity-item-preferred-field-checkbox">
                                {{ item.value }}
                            </mat-checkbox>
                            <mat-icon
                                class="cipo--cursor--pointer"
                                [class.material-icons-outlined]="highlightedField() !== item.key"
                                [color]="highlightedField() === item.key ? 'primary' : ''"
                                (click)="toggleHighlight(item)"
                                data-testid="activity-item-preferred-field-highlight">
                                info
                            </mat-icon>
                        </div>
                    }
                </div>
            </div>
        }
        @if (details.fields?.length) {
            <cipo-grid-form-view
                [fields]="activityFields()"
                [entityInstanceId]="details.entityInstanceId"
                [actionInstanceId]="details.actionInstanceId"
                [includeHistory]="details.type === ACTION_TYPES.UpdateDocument"
                data-testid="activity-item-form" />
        }
        @if (details.notifiedUsers?.length || details.sentToUsers?.length) {
            <div
                fxLayout
                fxLayout.lt-md="column"
                fxLayoutGap="20px"
                class="cipo--width--full m-y p-b-sm cipo--border-bottom--solid">
                @if (details.notifiedUsers?.length) {
                    <p fxFlex data-testid="activity-item-notified-users">
                        <span class="cipo--text-weight--bold m-r-xs">{{ "email.notified" | translate }}:</span>
                        <cipo-see-more [text]="details.notifiedUsers" dataType="userRoles" [limit]="3"></cipo-see-more>
                    </p>
                }
                @if (!details.hideRoutedTo && details.sentToUsers?.length) {
                    <p fxFlex data-testid="activity-item-sent-to-users">
                        <span class="cipo--text-weight--bold m-r-xs">{{ "email.routedTo" | translate }}:</span>
                        <cipo-see-more [text]="details.sentToUsers" dataType="userRoles" [limit]="3"></cipo-see-more>
                    </p>
                }
            </div>
        }
        @if (details.roleToExcludeIds?.length && details.canViewExcludedUsers) {
            <p data-testid="activity-item-excluded-roles">
                <span class="cipo--text-weight--bold m-r-xs">{{ "activity.excludedRoles" | translate }}:</span>
                <cipo-see-more [text]="rolesToExclude()" [limit]="3"></cipo-see-more>
            </p>
        }
        @if (details.type === ACTION_TYPES.Email) {
            <p data-testid="activity-item-emailed-to">
                <span>{{ "email.emailedTo" | translate }}:</span>
                <cipo-see-more [text]="emailRecipients()" [limit]="3" />
            </p>
        }
    } @else {
        <ngx-skeleton-loader [theme]="{ width: '100%', height: '12px', margin: '0' }"></ngx-skeleton-loader>
    }
</div>
